import { createEpicMiddleware } from 'redux-observable';

import { rootEpic } from '../state/epic';

export const epicMiddleware = createEpicMiddleware();

export const runEpicMiddleware = () => epicMiddleware.run(rootEpic);
